/* Imports */
/* ============================================================================= */
import { APPROVALS } from 'common/core/approvals_enums';
import { WorkflowGuidance } from 'common/types/approvals';

import { updateApprovalV2 } from 'common/core/approvals/guidanceLogic';





/* Method */
/* ============================================================================= */
/**
 * Approve an asset (for visibility change, updating published version, etc.)
 *
 * @param guidance WorkflowGuidance object
 * @param notes Notes to add when approving.
 * @returns A Promise object
 */
export const approveAssetV2 = (guidance: WorkflowGuidance, notes = ''): Promise<Response> => {
  const putBody = {
    state: APPROVALS.STATUS.APPROVED,
    notes
  };

  return updateApprovalV2(guidance, putBody);
};

export default approveAssetV2;
